/**
 * theme.js
 * Global, dependency-free behaviour: mobile navigation, product tabs and
 * the sidebar image slideshow. Ported from the React components
 * (mobile-header.tsx, product-tabs/index.tsx, sidebar/index.tsx).
 */
(function () {
  'use strict';

  /* ---------------------------------------------------------------------
   * Mobile navigation drawer
   * ------------------------------------------------------------------- */
  function initMobileNav() {
    var toggles = document.querySelectorAll('[data-mobile-nav-toggle]');
    var overlay = document.querySelector('[data-mobile-nav-overlay]');
    if (!overlay) return;
    var scrim = overlay.querySelector('[data-mobile-nav-scrim]');
    var closeButtons = overlay.querySelectorAll('[data-mobile-nav-close]');

    function open() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
    }

    function close() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', open);
    });
    if (scrim) scrim.addEventListener('click', close);
    closeButtons.forEach(function (btn) { btn.addEventListener('click', close); });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });
  }

  /* ---------------------------------------------------------------------
   * Product showcase tabs
   * ------------------------------------------------------------------- */
  function initProductTabs() {
    document.querySelectorAll('[data-product-tabs]').forEach(function (root) {
      var buttons = root.querySelectorAll('[data-tab-button]');
      var panels = root.querySelectorAll('[data-tab-panel]');

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          var index = button.getAttribute('data-tab-button');

          buttons.forEach(function (b) {
            b.classList.toggle('is-active', b === button);
          });
          panels.forEach(function (panel) {
            var isMatch = panel.getAttribute('data-tab-panel') === index;
            panel.hidden = !isMatch;
          });
        });
      });
    });
  }

  /* ---------------------------------------------------------------------
   * Inline video player (plays on the page instead of opening a new tab)
   * ------------------------------------------------------------------- */
  function initVideoPlayers() {
    document.querySelectorAll('[data-video-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        if (trigger.disabled) return;

        var container = trigger.closest('[data-video-player]');
        var frame = trigger.closest('.rich-text-block__video-frame');
        if (!container || !frame) return;
        var src = container.getAttribute('data-video-src');
        if (!src) return;

        var separator = src.indexOf('?') === -1 ? '?' : '&';
        var embedSrc = src + separator + 'autoplay=1';

        var iframe = document.createElement('iframe');
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        iframe.addEventListener('load', function () {
          iframe.classList.add('is-loaded');
        });

        // The thumbnail (trigger) stays underneath and only gets hidden once
        // the iframe has faded in on top of it, so there's no blank flash
        // while the video embed is booting up.
        trigger.disabled = true;
        trigger.setAttribute('aria-hidden', 'true');
        frame.appendChild(iframe);
        iframe.src = embedSrc;
      });
    });
  }

  /* ---------------------------------------------------------------------
   * Sidebar slideshow (auto-rotating images, matches setInterval(5000))
   * ------------------------------------------------------------------- */
  function initSidebarSlideshow() {
    document.querySelectorAll('[data-sidebar-slideshow]').forEach(function (root) {
      var slides = root.querySelectorAll('[data-slide]');
      if (slides.length < 2) return;
      var current = 0;

      setInterval(function () {
        slides[current].classList.remove('is-active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active');
      }, 5000);
    });
  }

  /* ---------------------------------------------------------------------
   * Shopify cookie preferences (footer legal bar link)
   * ------------------------------------------------------------------- */
  function initCookiePreferencesLink() {
    document.body.addEventListener('click', function (event) {
      var link = event.target.closest('a[href="#shopify-cookie-preferences"]');
      if (!link) return;

      event.preventDefault();

      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
      }
    });
  }

  /* ---------------------------------------------------------------------
   * Add to Cart - loading UI only; form still POSTs natively to /cart/add
   * Do not set button.disabled here — that can abort the native submit.
   * ------------------------------------------------------------------- */
  function initAddToCartButtons() {
    document.querySelectorAll('[data-add-to-cart-btn]').forEach(function (btn) {
      var form = btn.closest('form');
      if (!form) return;

      form.addEventListener('submit', function (e) {
        if (form.getAttribute('data-submitting') === 'true') {
          e.preventDefault();
          return;
        }
        form.setAttribute('data-submitting', 'true');

        var btnText = btn.querySelector('[data-btn-text]');
        var btnLoading = btn.querySelector('[data-btn-loading]');

        btn.setAttribute('aria-busy', 'true');
        btn.style.opacity = '0.6';
        btn.style.pointerEvents = 'none';
        if (btnText) btnText.hidden = true;
        if (btnLoading) btnLoading.hidden = false;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initProductTabs();
    initVideoPlayers();
    initSidebarSlideshow();
    initCookiePreferencesLink();
    initAddToCartButtons();
  });
})();
